import { render, staticRenderFns } from "./item-subject.vue?vue&type=template&id=6b45f8b5&scoped=true&"
import script from "./item-subject.vue?vue&type=script&lang=js&"
export * from "./item-subject.vue?vue&type=script&lang=js&"
import style0 from "./item-subject.vue?vue&type=style&index=0&id=6b45f8b5&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b45f8b5",
  null
  
)

export default component.exports